module.exports = __webpack_public_path__ + "static/media/baloon.6a837a4a.png";